<script setup>
import { useConfirmDialog } from '@/composables/useConfirm';
import Button from '@/components/ui/Button.vue';

const state = useConfirmDialog();

function answer(value) {
    if (!state.value) return;
    state.value.resolve(value);
    state.value = null;
}
</script>

<template>
    <Teleport to="body">
        <div
            v-if="state"
            class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
            @click.self="answer(false)"
        >
            <!-- Powierzchnia dialogu z kanonu nova: popover + ring, bez cienia -->
            <div data-testid="confirm-dialog" class="w-full max-w-sm rounded-xl bg-popover text-popover-foreground ring-1 ring-foreground/10 p-4 space-y-4">
                <div class="space-y-1">
                    <h3 class="font-medium text-base">{{ state.title }}</h3>
                    <p class="text-sm text-muted-foreground">{{ state.message }}</p>
                </div>
                <div class="flex gap-2 justify-end">
                    <Button variant="outline" size="sm" @click="answer(false)">Anuluj</Button>
                    <Button
                        size="sm"
                        data-testid="confirm-dialog-accept"
                        :variant="state.destructive ? 'destructive' : 'default'"
                        @click="answer(true)"
                    >
                        {{ state.confirmLabel ?? 'Confirm' }}
                    </Button>
                </div>
            </div>
        </div>
    </Teleport>
</template>
